var content = require("!!../node_modules/css-loader/dist/cjs.js!./commen1.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {"injectType":"styleTag"}

options.insert = "head";
options.singleton = false;

var update = require("!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
